export default __webpack_public_path__ + "static/media/Yuletide2021.53e977ca.png";